import { useState } from 'react';
import { usePointStore } from '../../../../store/pointStore';
import { useActiveMarker } from '../../../../store/markerStore';
import useLegendStore from '../../../../store/legendStore';

export const usePointLayerControl = () => {
  const [showPointSection, setShowPointsSection] = useState(true);

  const fwePoints = usePointStore((state) => state.fwePoints);
  const inSituPoints = usePointStore((state) => state.inSituPoints);
  const activeMarker = useActiveMarker();

  const showLabelLayer = useLegendStore((state) => state.showLabelLayer);
  const setShowLabelLayer = useLegendStore((state) => state.setShowLabelLayer);
  const showFWEPoints = useLegendStore((state) => state.showFWEPoints);
  const setShowFWEPoints = useLegendStore((state) => state.setShowFWEPoints);
  const showInSituPoints = useLegendStore((state) => state.showInSituPoints);
  const setShowInSituPoints = useLegendStore(
    (state) => state.setShowInSituPoints
  );

  const isHavePoint = activeMarker && activeMarker.id !== undefined;
  const isHaveFwePoint = fwePoints && fwePoints.length > 0;
  const isHaveInsituPoint = inSituPoints && inSituPoints.length > 0;
  const isHave2DSpectra = activeMarker?.shapeFiles.some(
    (item) =>
      item.Level1 === '2D Wave Spectra' || item.Level2 === '2D Wave Spectra'
  );

  const updateShowLabels = (state: boolean) => {
    setShowLabelLayer(state);
  };

  return {
    showPointSection,
    setShowPointsSection,
    showLabelLayer,
    showFWEPoints,
    showInSituPoints,
    isHavePoint,
    isHaveFwePoint,
    isHaveInsituPoint,
    isHave2DSpectra,
    updateShowLabels,
    setShowFWEPoints,
    setShowInSituPoints,
  };
};
